const baseUrl = import.meta.env.VITE_API_BASE_URL;
const WARMUP_INTERVAL_MS = 5 * 60 * 1000;

let lastPingTime = 0;

const serverWarmupService = {
    pingServer: function() {
        const now = Date.now();
        if (now - lastPingTime < WARMUP_INTERVAL_MS) return;
        lastPingTime = now;
        fetch(baseUrl + "/api/health/pingserver").catch(() => {});
    }
};

export default serverWarmupService;